/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { MuiThemeProvider } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import "../../themes/fonts/font.scss";
import { theme } from "../../themes/theme";
import "./layout.scss";
import SEO from "../../templates/seo";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import ModernNav from "../NewHomePage/ModernNav";
import FooterLazy from "../../templates/Footer";
//cookie banner
import CookieConsentLazy from "react-cookie-consent";
import ModalComponent from "../Modal";
import FormSection from "../FormSection";
import { ContactModalProvider } from "../Modal/contactModalContext";
import { PopupAssignmentProvider } from "../PopupAssignmentContext/index";
import PopupAssignmentManager from "../PopupAssignmentManager/index";
import * as Yup from "yup";
import { Formik } from "formik";
import DataService from "../../services/api/data_services";
import { navigate } from "gatsby";
import RevealAnimation from "../RevealAnimation";
import InputComponent from "../input";

const Layout = ({
  children,
  seo,
  isLandingPage = false,
  pageUrl = "",
  showHeader = true,
  isIndexPage = false,
  handleClick = () => {},
  redirectContactTo = "",
}) => {
  const [delayRender, setDelayRender] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showFixedButton, setShowFixedButton] = useState(false);
  const [location, setLocation] = useState("");


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFixedButton(true);
    }, 5000); // 5 seconds delay

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleContactLinkClick = (e) => {
      const link = e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
      if (!link) return;

      const isPhone = link.href.startsWith("tel:");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: isPhone ? "phone_click" : "email_click",
        page_location: window.location.href,
        contact_method: isPhone ? "phone" : "email",
      });
    };

    document.addEventListener("click", handleContactLinkClick);
    return () =>
      document.removeEventListener("click", handleContactLinkClick);
  }, []);

  useEffect(() => {
    // Hide loader after 2 seconds
    const timeout = setTimeout(() => {
      setDelayRender(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  if (typeof window !== `undefined`) {
    window.onscroll = function () {
      myFunction();
    };
  }

  function myFunction() {
    if (typeof window.orientation == "undefined") {
      let stickyCondition =
        document.getElementsByClassName("sub-title-height-clicked").length > 0
          ? 300
          : 360;
      toggleSticky(stickyCondition);
    }
    if (typeof window.orientation == "number") {
      let stickyCondition =
        document.getElementsByClassName("sub-title-height-clicked").length > 0
          ? 80
          : 80;
      // let stickyCondition = document.getElementsByClassName('sub-title-height-clicked').length > 0 ? 250 : 250;
      toggleSticky(stickyCondition);
    }

    function toggleSticky(stickyCondition) {
      let stickyClass =
        document.getElementsByClassName("sub-title-height-clicked").length > 0
          ? "sticky-clicked"
          : "sticky";

      if (
        document.body.scrollTop > stickyCondition ||
        document.documentElement.scrollTop > stickyCondition
      ) {
        document.getElementById("ImgSubTitle") &&
          document.getElementById("ImgSubTitle").classList.add(stickyClass);
      } else {
        document.getElementById("ImgSubTitle") &&
          document.getElementById("ImgSubTitle").classList.remove(stickyClass);
      }
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        document.getElementById("header") &&
          document.getElementById("header").classList.add("toolbar_onscroll");
        // document.getElementById("main-container") &&
        //   document.getElementById("main-container").classList.add("mt-100");
      } else {
        document.getElementById("header") &&
          document
            .getElementById("header")
            .classList.remove("toolbar_onscroll");
        // document.getElementById("main-container") &&
        //   document.getElementById("main-container").classList.remove("mt-100");
      }
    }
  }
  const validateSchema = Yup.object().shape({
    firstName: Yup.string().required("This field is required"),
    lastName: Yup.string().required("This field is required"),

    email: Yup.string()
      .email("Please enter a valid email")
      .required("This field is required"),
    phone: Yup.string()
      .required("This field is required")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid",
      ),
    organization: Yup.string().required("This field is required"),
    jobTitle: Yup.string().required("This field is required"),
    message: Yup.string().required("This field is required"),
  });

  useEffect(() => {
    DataService.getData(`https://ipapi.co/json/`).then((res) =>
      setLocation(res.city),
    );
  }, []);

  const handleSubmit = (formData) => {
    // setapproval(false);
    setIsLoading(true);
    DataService.postData(
      `admin/api/sendmail`,
      { ...formData, location: location },
      {
        type: "contactus_new",
      },
    )
      .then((response) => {
        if (typeof window !== `undefined`) {
          navigate(`/thank-you-contact${pageUrl}`);
        }
      })
      .catch((error) => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const urlPathname = typeof window !== "undefined" ? window.location.href : "";

  return (
    <MuiThemeProvider theme={theme}>
      <SEO
        title={seo?.title}
        ogtitle={seo?.ogtitle}
        description={seo?.description}
        ogimage={seo?.ogimage}
        ogurl={seo?.ogurl}
        keywords={seo?.keywords}
        type={seo?.type}
      />
      <ContactModalProvider>
          <PopupAssignmentProvider>
            {showHeader && <ModernNav isIndexPage={isIndexPage} />}
            <div style={{ backgroundColor: "white" }}>
              <main
                id="main-container"
                style={
                  showHeader && !isIndexPage ? { paddingTop: 70 } : undefined
                }
              >
                {children}
              </main>
              {!isLandingPage && (
                <footer>
                  <FooterLazy />
                </footer>
              )}
              {!delayRender && (
                <CookieConsentLazy
                  containerClasses="cookie-banner-style"
                  onDecline={() => {
                    console.log("User rejected cookies");
                  }}
                  enableDeclineButton
                  declineButtonText="REJECT"
                  buttonText="ACCEPT"
                  hideOnAccept
                  hideOnDecline
                  acceptOnScrollPercentage={80}
                  cookieName="gatsby-gdpr-google-analytics"
                  declineButtonClasses="cookie-decline-btn"
                  buttonClasses="cookie-accept-btn"
                  contentClasses="cookie-content"
                  buttonWrapperClasses="cookie-button-wrapper"
                >
                  <div className="cookie-text">
                    <strong>🍪 We use cookies</strong>
                    <p>
                      We use cookies on our website to improve the quality of
                      user experience. By continuing to use this site, you agree
                      to our{" "}
                      <a
                        className="cookie-tagclass"
                        target="_blank"
                        href="/cookie-policy"
                      >
                        cookie policy
                      </a>
                      .
                    </p>
                  </div>
                </CookieConsentLazy>
              )}
            </div>
            <ModalComponent>
              <FormSection showCloseButton pageUrl={pageUrl} />
            </ModalComponent>

            <div className="main-page-popup">
              {showFixedButton && (
                <div
                  className="fixedBtn"
                  onClick={() => {
                    redirectContactTo === ""
                      ? setShowForm(!showForm)
                      : navigate(redirectContactTo);
                  }}
                >
                  Contact us
                </div>
              )}
              {showForm && (
                <div className="contact-form-wrapper">
                  <div
                    className="popup_close_btn"
                    onClick={() => {
                      setShowForm(false);
                    }}
                  >
                    &#10005;
                  </div>
                  <div className="contact-form-container">
                    <RevealAnimation
                      component={"h3"}
                      className="popup_card_header"
                    >
                      <span className="red-line3letter red-3letter-mbl">
                        Get{" "}
                      </span>
                      in touch
                    </RevealAnimation>

                    <Formik
                      initialValues={{
                        firstName: "",
                        lastName: "",
                        email: "",
                        phone: "",
                        jobTitle: "",
                        organization: "",
                        message: "",
                        opt_in: false,
                        privacy_policy: true,
                        location: location,
                        source: urlPathname,
                      }}
                      validationSchema={validateSchema}
                      onSubmit={(values) => {
                        handleSubmit(values);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleSubmit,
                        handleChange,
                      }) => {
                        return (
                          <div className="contact-form">
                            <div className="mt-10">
                              <InputComponent
                                value={values.firstName}
                                name="firstName"
                                onChange={handleChange}
                                label="First Name"
                                is_error={errors.firstName && touched.firstName}
                                error_message={errors.firstName}
                                wrapClassName="w-half"
                                className="contact-form_input"
                              />
                            </div>
                            <div className="mt-10">
                              <InputComponent
                                value={values.lastName}
                                name="lastName"
                                onChange={handleChange}
                                label="Last Name"
                                is_error={errors.lastName && touched.lastName}
                                error_message={errors.lastName}
                                wrapClassName="w-half"
                                className="contact-form_input"
                              />
                            </div>
                            <div className="mt-10">
                              <InputComponent
                                value={values.email}
                                name="email"
                                onChange={handleChange}
                                label="Business Email"
                                is_error={errors.email && touched.email}
                                error_message={errors.email}
                                wrapClassName="w-half"
                                className="contact-form_input"
                              />
                            </div>
                            <div className="mt-10 ">
                              <InputComponent
                                value={values.phone}
                                name="phone"
                                onChange={handleChange}
                                label="Phone Number"
                                is_error={errors.phone && touched.phone}
                                error_message={errors.phone}
                                wrapClassName="w-half"
                                className="contact-form_input"
                              />
                            </div>

                            <div className="mt-10 ">
                              <InputComponent
                                value={values.jobTitle}
                                name="jobTitle"
                                onChange={handleChange}
                                label="Job Title"
                                is_error={errors.jobTitle && touched.jobTitle}
                                error_message={errors.jobTitle}
                                wrapClassName="w-half"
                                className="contact-form_input"
                              />
                            </div>

                            <div className="mt-10">
                              <InputComponent
                                value={values.organization}
                                name="organization"
                                onChange={handleChange}
                                label="Company Name"
                                is_error={
                                  errors.organization && touched.organization
                                }
                                error_message={errors.organization}
                                className="contact-form_input"
                              />
                            </div>
                            <div className="mt-10">
                              <InputComponent
                                value={values.message}
                                name="message"
                                onChange={handleChange}
                                label="Message"
                                placeholder="Write your message.."
                                is_error={errors.message && touched.message}
                                error_message={errors.message}
                                type={"textarea"}
                                className="textarea"
                              />
                            </div>
                            <button
                              className="submit-button"
                              type="submit"
                              onClick={handleSubmit}
                              disabled={isLoading}
                            >
                              <div className="custom-form-width-btn">
                                Send Now
                                <span className="btn-icon">
                                  <KeyboardArrowRightOutlinedIcon />
                                </span>
                              </div>
                            </button>
                          </div>
                        );
                      }}
                    </Formik>

                    <div className="list-item-content mt-10">
                      {["100% confidential", "We sign NDAs"].map(
                        (item, index) => (
                          <div key={index} className="list-item-child">
                            <svg
                              width="22"
                              height="18"
                              viewBox="0 0 18 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                y="0.26825"
                                width="24"
                                height="24"
                                rx="12"
                                fill="#E89F38"
                              />
                              <path
                                d="M18 5.86823L17.8364 5.75312L17.8363 5.75327L17.8359 5.75391L17.834 5.75655L17.8265 5.76719L17.7965 5.80952C17.77 5.84695 17.7303 5.9026 17.6783 5.97528C17.5743 6.12065 17.4205 6.33415 17.2221 6.60627C16.8253 7.15052 16.2497 7.92922 15.5354 8.86637C14.1064 10.7409 12.1229 13.2483 9.90367 15.7811C9.37776 16.381 8.90051 16.6 8.49311 16.6261C8.08233 16.6524 7.70105 16.4853 7.36422 16.2294C7.02742 15.9736 6.75049 15.6402 6.55592 15.3658C6.45924 15.2295 6.38428 15.1097 6.33373 15.0244C6.30847 14.9818 6.28938 14.948 6.27678 14.9251L6.26281 14.8994L6.25956 14.8932L6.25889 14.8919L6.25886 14.8919C6.25884 14.8918 6.25882 14.8918 6.25881 14.8918L6.2588 14.8918C6.2192 14.8152 6.13499 14.7726 6.04984 14.7861C5.96465 14.7996 5.89771 14.8662 5.88377 14.9513C5.69619 16.0971 5.8337 16.9783 6.19672 17.6173C6.56149 18.2594 7.14102 18.634 7.78759 18.7867C9.06416 19.0883 10.625 18.5323 11.4303 17.46L11.4304 17.46C12.5341 15.9903 14.2229 13.1104 15.6303 10.6091C16.3354 9.3562 16.9719 8.19455 17.4321 7.34617C17.6622 6.92195 17.8483 6.576 17.9769 6.33607C18.0412 6.2161 18.0911 6.12263 18.125 6.05912L18.1635 5.98677L18.1733 5.96827L18.1758 5.96357L18.1764 5.96238L18.1766 5.96208C18.1766 5.96201 18.1767 5.96197 18 5.86823ZM18 5.86823L17.8365 5.75308C17.8973 5.66675 18.0147 5.64254 18.1047 5.69779C18.1946 5.75304 18.2262 5.86871 18.1767 5.96197L18 5.86823Z"
                                fill="white"
                                stroke="white"
                                strokeWidth="0.4"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <p>{item}</p>
                          </div>
                        ),
                      )}
                    </div>

                    <p>
                      To give you the content requested, we need to store and
                      process your personal data. For information on how to
                      unsubscribe, as well as our privacy practices and
                      commitment to protecting your privacy, please review our{" "}
                      <a
                        className="atagclass"
                        target="_blank"
                        href="/privacy-policy"
                      >
                        Privacy Policy.
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </PopupAssignmentProvider>
        </ContactModalProvider>
    </MuiThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
